<div class="header-wrapper" title="{{params.displayName}}">
  {{params.displayName}}
</div>
<button title="{{  'plan.dist.copy.base.tooltip' | translate}}" *ngIf="isResetAvailable"  [ngClass]="{'disabled': isValid()}" [disabled]="isValid()"
        class="btn icon-file-file-copy" [ngbPopover]="confirmReset" triggers="click" container="body" popoverClass="reset-popup" data-testid="copy-base-icon"></button>


<ng-template #confirmReset>
  <div class="message-text">
    <p>{{"plan.dist.copy.base.msg" | translate }} </p>
  </div>
  <div class="button-response">
    <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}"></breeze-button>
    <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="copyBase()"></breeze-button>
  </div>
</ng-template>

